import { Component, OnInit } from '@angular/core';

import { LoadingService } from 'src/app/services/loading/loading.service';

@Component({
    selector: 'app-loading',
    templateUrl: './loading.component.html'
})
export class LoadingComponent implements OnInit{
    loading!: boolean;

    constructor(private readonly loadingService: LoadingService) { }

    ngOnInit(): void {
        this.loadingService.loading.subscribe({
            next: loading => {
                this.loading = loading;
            }
        });
    }
}
